import { apiCall } from './BaseAction';
import { Dispatch } from 'redux';
import {
  AddTaskComment,
  DeleteTaskComment,
  DeleteTaskFile,
  FilterTasksList,
  GetTaskDetail,
  GetTasksList,
  TaskPriorityType,
  TaskStatusType,
  TAddTaskCommentAction,
  TDeleteTaskCommentAction,
  TDeleteTaskFileAction,
  TFilterTasksListAction,
  TGetTaskDetailAction,
  TGetTasksListAction,
  TUpdateTaskAction,
  TUploadTaskFileAction,
  TSubmitConclusionAction,
  UpdateTask,
  UploadTaskFile,
  SubmitConclusion,
} from '../types/Tasks';

export const getTasksList = () => {
  return apiCall<TGetTasksListAction, null>(
    GetTasksList,
    'GET',
    '/tasks',
    true
  );
};

export const filterTasksList = (
  search: string,
  statuses: TaskStatusType[],
  priorities: TaskPriorityType[]
) => {
  return (dispatch: Dispatch<TFilterTasksListAction>) => {
    localStorage.setItem('tasks_filter_statuses', JSON.stringify(statuses));
    localStorage.setItem('tasks_filter_priorities', JSON.stringify(priorities));

    dispatch({
      type: FilterTasksList.SUBMIT,
      payload: { search, statuses, priorities },
    });
  };
};

export const getTaskDetail = (taskId: number) => {
  return apiCall<TGetTaskDetailAction, null>(
    GetTaskDetail,
    'GET',
    `/tasks/${taskId}`,
    true,
    null,
    {},
    true
  );
};

export const addTaskComment = (taskId: number, comment: string) => {
  return apiCall<TAddTaskCommentAction, { comment: string }>(
    AddTaskComment,
    'POST',
    `/tasks/${taskId}/comment`,
    true,
    { comment }
  );
};

export const deleteTaskComment = (taskId: number, commentId: number) => {
  return apiCall<TDeleteTaskCommentAction>(
    DeleteTaskComment,
    'DELETE',
    `/tasks/${taskId}/comment/${commentId}`,
    true
  );
};

export const uploadTaskFile = (
  taskId: number,
  filename: string,
  content: string
) => {
  return apiCall<TUploadTaskFileAction, { filename: string; content: string }>(
    UploadTaskFile,
    'POST',
    `/tasks/${taskId}/file`,
    true,
    { filename, content }
  );
};

export const deleteTaskFile = (taskId: number, fileId: number) => {
  return apiCall<TDeleteTaskFileAction>(
    DeleteTaskFile,
    'DELETE',
    `/tasks/${taskId}/file/${fileId}`,
    true
  );
};

export const submitConclusion = (taskId: number, conclusionStatus: number) => {
  return apiCall<TSubmitConclusionAction, { conclusionStatus: number }>(
    SubmitConclusion,
    'POST',
    `/tasks/${taskId}/conclusion`,
    true,
    { conclusionStatus }
  );
};

export const updateTask = (
  taskId: number,
  data: {
    statusId?: number | null;
    priorityId?: number | null;
    assigneeEmail?: string | null;
    notifyAssignee?: boolean;
    notifyAssigneeComment?: string | null;
  }
) => {
  return apiCall<TUpdateTaskAction, typeof data>(
    UpdateTask,
    'PUT',
    `/tasks/${taskId}`,
    true,
    data
  );
};
